module.exports = __webpack_public_path__ + "img/default-profile-pic.fab49ee8.svg";